// Mantine
import {
    Button,
    NumberInput,
    ActionIcon,
    Tooltip,
    Popover,
    Modal,
} from '@mantine/core'

import { modals } from '@mantine/modals'

import { DatePickerInput } from '@mantine/dates'

// React
import { useState } from 'react'

// Icons
import {
    IconArrowsSplit,
    IconCalendarEvent,
    IconTrash,
} from '@tabler/icons-react'

// Dayjs
import dayjs from 'dayjs'

// UI
import SKU from '../ui/SKU'

export default function PurchaseOrderLineEdit({ lines, line, handlers }) {
    // Component full name
    const componentFullName = `${line.component.component_category.name_fr} — ${line.component.name}`

    // Confirm delete
    const openDeleteModal = () => {
        modals.openConfirmModal({
            title: 'Supprimer la ligne',
            centered: true,
            size: 'lg',
            children: (
                <div className="flex flex-col text-center mb-10 mt-5">
                    <span className="font-medium">
                        {line.quantity_to_receive}× {componentFullName} - BOC
                        {line.component_id}
                    </span>
                    <span>
                        {line.reception_at
                            ? dayjs(line.reception_at).format('LL')
                            : ' Sans date de reception'}
                    </span>
                </div>
            ),
            labels: {
                confirm: 'Supprimer la ligne',
                cancel: 'Ne pas la supprimer',
            },
            confirmProps: { color: 'red' },
            onConfirm: () => handlers.deleteLine(line),
        })
    }

    // Change reception date of the line
    const [isChangingReceptionDate, setIsChangingReceptionDate] =
        useState(false)

    const [receptionDate, setReceptionDate] = useState(
        line.reception_at ? dayjs(line.reception_at) : null
    )

    const openReceptionDateModal = () => {
        setReceptionDate(line.reception_at ? dayjs(line.reception_at) : null)
        setIsChangingReceptionDate(true)
    }

    const closeReceptionDateModal = () => {
        setIsChangingReceptionDate(false)
    }

    const changeReceptionDate = () => {
        if (receptionDate) {
            handlers.changeLineReceptionDate(
                line,
                dayjs(receptionDate).format('YYYY-MM-DD')
            )
        }

        closeReceptionDateModal()
    }

    return (
        <>
            <div
                key={line.component_id}
                className="flex items-center justify-between"
            >
                <div className="flex flex-col items-start">
                    <div className="flex items-center gap-2">
                        <SKU component={line.component} size="sm" />
                        <span>{componentFullName}</span>
                    </div>

                    <span className="text-gray-400">
                        {line.quantity_received ?? 0} réceptionnés
                    </span>
                </div>

                <div className="flex items-center gap-3">
                    <ActionIcon.Group>
                        <Tooltip label="Modifier la date">
                            <ActionIcon
                                variant="default"
                                color="gray"
                                onClick={openReceptionDateModal}
                            >
                                <IconCalendarEvent size={14} />
                            </ActionIcon>
                        </Tooltip>
                        {false && (
                            <Tooltip label="Scinder en plusieurs dates">
                                <ActionIcon variant="default" color="gray">
                                    <IconArrowsSplit size={14} />
                                </ActionIcon>
                            </Tooltip>
                        )}

                        <Tooltip label="Supprimer la ligne">
                            <ActionIcon
                                variant="default"
                                color="gray"
                                onClick={openDeleteModal}
                            >
                                <IconTrash size={14} />
                            </ActionIcon>
                        </Tooltip>
                    </ActionIcon.Group>

                    <NumberInput
                        w={90}
                        value={line.quantity_to_receive}
                        onChange={(value) => {
                            const new_quantity_to_receive =
                                value < 1 ? 1 : value

                            handlers.changeLineQuantityToReceive(
                                line,
                                new_quantity_to_receive
                            )
                        }}
                    />
                </div>
            </div>

            <Modal
                opened={isChangingReceptionDate}
                onClose={closeReceptionDateModal}
                title="Modifier la date de réception"
                size="lg"
            >
                <div className="flex flex-col gap-4">
                    {true && (
                        <DatePickerInput
                            value={receptionDate}
                            onChange={setReceptionDate}
                            label="Date de réception"
                            placeholder="Date de réception"
                            description="La date la plus pessimiste de réception du composant"
                            valueFormat="LL"
                            minDate={new Date()}
                            locale="fr"
                        />
                    )}

                    <div className="flex flex-col">
                        <span className="font-medium text-sm">Composant</span>

                        <span className="">
                            {line.quantity_to_receive}× {componentFullName}
                        </span>
                        <span className="text-gray-400">
                            BOC{line.component_id}
                        </span>
                    </div>

                    <div className="w-full grid grid-cols-2 gap-3">
                        <Button
                            variant="default"
                            onClick={closeReceptionDateModal}
                        >
                            Annuler
                        </Button>
                        <Button
                            onClick={() => changeReceptionDate(receptionDate)}
                        >
                            Enregistrer la nouvelle date
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    )
}
